import { ReactNode } from 'react'
import { copyToClipboard } from '../lib/clipboard'
import { toast } from 'sonner'
import { hapticSubtle } from '../lib/haptics'

interface TextProps {
  big?: boolean
  bigger?: boolean
  bold?: boolean
  capitalize?: boolean
  centered?: boolean
  children: ReactNode
  color?: string
  copy?: string
  heading?: boolean
  large?: boolean
  medium?: boolean
  right?: boolean
  smaller?: boolean
  small?: boolean
  testId?: string
  thin?: boolean
  tiny?: boolean
  tooltip?: string
  wrap?: boolean
}

export default function Text({
  big,
  bigger,
  bold,
  capitalize,
  centered,
  children,
  color,
  copy,
  heading,
  large,
  medium,
  right,
  smaller,
  small,
  testId,
  thin,
  tiny,
  tooltip,
  wrap,
}: TextProps) {
  const fontSize = tiny ? 12 : smaller ? 13 : small ? 14 : big ? 24 : bigger ? 32 : large ? 18 : 16

  const className = capitalize ? 'first-letter' : ''

  const pStyle: any = {
    color: color ? `var(--${color})` : undefined,
    cursor: copy ? 'pointer' : undefined,
    fontFamily: heading ? 'var(--font-heading)' : undefined,
    fontSize,
    fontWeight: thin ? '400' : medium ? '500' : bold ? (heading ? '700' : '600') : undefined,
    letterSpacing: heading ? '-0.5px' : undefined,
    lineHeight: heading ? (bigger || big ? '1.2' : large ? '1.4' : '1.5') : tiny ? '1' : '1.5',
    overflow: wrap ? undefined : 'hidden',
    textAlign: centered ? 'center' : right ? 'right' : undefined,
    textOverflow: wrap ? undefined : 'ellipsis',
    whiteSpace: wrap ? undefined : 'nowrap',
    wordBreak: 'break-word',
  }

  const handleClick = async () => {
    if (!copy) return
    hapticSubtle()
    try {
      await copyToClipboard(copy)
      toast('Copied to clipboard')
    } catch {
      toast('Failed to copy')
    }
  }

  return (
    <div data-testid={testId} style={{ minWidth: 0 }}>
      <p className={className} onClick={handleClick} style={pStyle} title={tooltip}>
        {children}
      </p>
    </div>
  )
}

export function TextLabel({ children }: TextProps) {
  return (
    <div style={{ padding: '0 1rem 0.5rem 1rem' }}>
      <Text capitalize color='neutral-500' smaller>
        {children}
      </Text>
    </div>
  )
}

export function TextSecondary({ centered, children }: TextProps) {
  return (
    <Text centered={centered} color='neutral-500' small thin wrap>
      {children}
    </Text>
  )
}
